import React, { useEffect } from "react";
import { useAtomValue } from "jotai";

import PaymentStatusTemplate, {
  PaymentStatusType,
} from "../../../components/Payments/PaymentStatusTemplate/PaymentStatusTemplate";
import EventDispatcher from "../../../utils/event-dispatcher";
import {
  EventTypes,
  MOBILE_APP_TO_WEB_APP_ROUTE_MAP,
  ROUTES,
} from "../../../utils/constants";
import { renderHeaders } from "../../../utils/renderHeaders";
import HourglassIcon from "../../../components/icons/HourglassIcon";
import useEffectAfterMount from "../../../hooks/useEffectAfterMount";
import useAnalytics from "../../../hooks/useAnalytics";
import { topupInfoAtom, paymentStatusAtom } from "../../../jotai/atoms/topup";

const REDIRECT_ROUTE = ROUTES.WALLET.TOPUP_PENDING;

function PaymentPendingMobile() {
  const { sendCompleteTopupEvent } = useAnalytics();
  const topupInfo = useAtomValue(topupInfoAtom);
  const paymentStatus = useAtomValue(paymentStatusAtom);

  useEffect(() => {
    EventDispatcher.dispatch(EventTypes.PAYMENTS.ERROR, {
      message: "Payment pending",
    });
    window.location.href = MOBILE_APP_TO_WEB_APP_ROUTE_MAP[REDIRECT_ROUTE];
  }, []);

  useEffectAfterMount(() => {
    if (topupInfo?.provider && paymentStatus) {
      const {
        provider,
        amount,
        price,
        isFirstTime,
        bonusHpr,
        gem,
        topUpUniqueId,
      } = topupInfo;
      sendCompleteTopupEvent({
        hpr_amount: amount,
        bonus_hpr_amount: bonusHpr ?? 0,
        gem_amount: gem ?? 0,
        fiat_amount: price ?? 0,
        first_time_top_up: isFirstTime,
        transaction_status: paymentStatus,
        payment_option: provider.toLowerCase(),
        topUpUniqueId,
      });
    }
  }, [topupInfo, paymentStatus, sendCompleteTopupEvent]);

  return (
    <>
      {renderHeaders({
        title: "Payment Pending | Hyper by Metaverse Magna",
        description: "",
      })}

      <PaymentStatusTemplate
        type={PaymentStatusType.DONE}
        title="Payment pending"
        message="Your payment is on the way. Your wallet will be credited if your payment is confirmed."
        eventType={EventTypes.PAYMENTS.ERROR}
        navigateUrl={REDIRECT_ROUTE}
        icon={<HourglassIcon />}
      />
    </>
  );
}

export default PaymentPendingMobile;
